import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import { Form } from "react-bootstrap";
import AccordionData from "./AccordionData";
import VideoUpload from "../DashboardComponents/ClubFitting Video view/VideoUpload";
import VideoUpload2 from "../DashboardComponents/ClubFitting Video view/VideoUpload2";
import { Link, useParams } from "react-router-dom";
import { IoClose, IoEye } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { getremoteInquirydataApi } from "../../Api/iron"
import { getCurrentUser } from "../../Api/auth";
import { deleteProjectApi, addnotes, getnotes } from "../../Api/prescriptionApis"
import Button from 'react-bootstrap/Button';
import { ReactNotifications, Store } from 'react-notifications-component'
import { useHistory } from 'react-router-dom';
import { getPrescription } from "../../Api/prescriptionApis";
import Loader2 from "../DashboardComponents/Loader/Loader2";


function ClubFittingLeft({notesdata ,prescription ,formDatauser,remotefittingimageimges,remotefittingdataofdata}) {

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const [validated, setValidated] = useState(false);
    const [firstvideo, setFirstVideo] = useState(null);
    const [secondvideo, setSecondVideo] = useState(null);
    const [apicall, setApicall] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const params = useParams();

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: ""
    };

    const [resultoutput, setResultoutput] = useState({
        white: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        black: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        blue: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        pink: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        purple: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        red: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        orange: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        green: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
    });


    const [formData, setFormData] = useState(initData);
    const [remotefittingdata, setRemotefittingdata] = useState([]);
    const [remotefittingimage, setRemotefittingimage] = useState([]);
    // const [notesdata, setnotesData] = useState([]);
    const [prescriptionid, setPrescriptionid] = useState(null)


    const handleCloseConfirmation = () => setShowConfirmation(false);
    const handleShowConfirmation = () => setShowConfirmation(true);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [user_id, setUser_id] = useState(0);
    const [notes, setnotes] = useState('')

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        // const handleScroll = () => {
        //     const scrollTop = window.scrollY;
        //     if (scrollTop > 50) {
        //         setScrolled(true);
        //     } else {
        //         setScrolled(false);
        //     }
        // };

        // window.addEventListener('scroll', handleScroll);
        // return () => {
        //     window.removeEventListener('scroll', handleScroll);
        // };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    
    useEffect(() => {
        if(formDatauser){
            setFormData(formDatauser);
        }
    },[formDatauser]);

    useEffect(() => {
        if(remotefittingimageimges){
            setRemotefittingimage(remotefittingimageimges);
        }
    },[remotefittingimageimges]);

    useEffect(() => {
        if(remotefittingdataofdata){
            setRemotefittingdata(remotefittingdataofdata);
            // manageResult(remotefittingdataofdata);
        }
    },[remotefittingdataofdata]);

    const getDataById = () => {
        // setIsLoading(true);
        // getremoteInquirydataApi({ id: params.id }).then((res) => {
        //     console.log("aminesh ++", "7");
        //     if (res?.code === 200) {
        //         const userData = res.data.data;
        //         setFormData(userData);
        //         setRemotefittingdata(userData.remotefittingdata);
        //         setRemotefittingimage(userData.remotefittingimage);
        //         manageResult(userData.remotefittingdata);
        //     } else {
        //         // alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // }).finally(() => {
        //     setIsLoading(false);
        // });
    }

    useEffect(() => {
        getDataById()
        handlegetnotes();
    }, [params])

    const options1 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options2 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const options3 = [
        { id: 1, text: 'Pull Hook' },
        { id: 2, text: 'Pull Straight' },
        { id: 3, text: 'Pull Fade' },
        { id: 4, text: 'Straight' },
        { id: 5, text: 'Push Draw' },
        { id: 6, text: 'Push Strait' },
        { id: 7, text: 'Push Slice' },
    ];

    const shotOpction = [
        { id: 1, text: 'On Target' },
        { id: 2, text: 'Left Of Target' },
        { id: 2, text: 'Right Of Target' },
    ]

    const shortStrike = [
        { id: 1, text: 'Tiger Strike' },
        { id: 2, text: 'No Tiger Strike' },
    ]

    const deleteproject = () => {

        deleteProjectApi({ id: params.id }).then((res) => {
            if (res?.code === 200) {
                window.location.href = "/project/clubfitting";
            } else {
                alert(res?.message);
            }
        }).catch((err) => {
            alert(err);
        })

    }

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUser_id(getCurrentUserdata.user._id);
        } else {
            console.error("Current user data is null or undefined");
        }
        getprojectdata();

    }, []);

    const handlegetnotes = () => {
        // setApicall(true);


        // const data = {
        //     project_id: params.id
        // }

        
        // getnotes(data).then((response) => {
        //     if (!response.data.status) {
        //         console.log(response.data.message);
        //     } else {
        //         const data = response.data.data;
        //         setnotesData(data);
        //     }
        // }).catch((err) => {
        //     console.log(err);
        // }).finally(() => {
        //     console.log("data", "1");
        //     setApicall(false);
        //     setValidated(true);
        // });
    };

    // const manageResult = (result) => {



    //     console.log("resulttt", result);
    //     const getwhitelabel = getLebel(result?.step1);
    //     const getblacklabel = getLebel(result?.step2);
    //     const getbluelabel = getLebel(result?.step3);
    //     const getpinklabel = getLebel(result?.step4);
    //     const getpurplelabel = getLebel(result?.step5);
    //     const getredlabel = getLebel(result?.step6);
    //     const getorangelabel = getLebel(result?.step7);
    //     const getgreenlabel = getLebel(result?.step8);
 
    //     setResultoutput({
    //         white: getwhitelabel,
    //         black: getblacklabel,
    //         blue: getbluelabel,
    //         pink: getpinklabel,
    //         purple: getpurplelabel,
    //         red: getredlabel,
    //         orange: getorangelabel,
    //         green: getgreenlabel,

    //     });
    // }

    // useEffect(() => {

    // }, [resultoutput]);


    // const getLebel = (step) => {

        
    //     var lowestIron = 0;
    //     var bestLabel = "";
    //     var bestposition = 1;
    //     const iron1_shot1 = parseInt(step?.iron1?.shot1?.optionx_value) + parseInt(step?.iron1?.shot1?.optiony_value) + parseInt(step?.iron1?.shot1?.option1_value) + parseInt(step?.iron1?.shot1?.option2_value);
    //     const iron1_shot2 = parseInt(step?.iron1?.shot2?.optionx_value) + parseInt(step?.iron1?.shot2?.optiony_value) + parseInt(step?.iron1?.shot2?.option1_value) + parseInt(step?.iron1?.shot2?.option2_value);
    //     const iron1_shot3 = parseInt(step?.iron1?.shot3?.optionx_value) + parseInt(step?.iron1?.shot3?.optiony_value) + parseInt(step?.iron1?.shot3?.option1_value) + parseInt(step?.iron1?.shot3?.option2_value);

    //     const iron2_shot1 = parseInt(step?.iron2?.shot1?.optionx_value) + parseInt(step?.iron2?.shot1?.optiony_value) + parseInt(step?.iron2?.shot1?.option1_value) + parseInt(step?.iron2?.shot1?.option2_value);
    //     const iron2_shot2 = parseInt(step?.iron2?.shot2?.optionx_value) + parseInt(step?.iron2?.shot2?.optiony_value) + parseInt(step?.iron2?.shot2?.option1_value) + parseInt(step?.iron2?.shot2?.option2_value);
    //     const iron2_shot3 = parseInt(step?.iron2?.shot3?.optionx_value) + parseInt(step?.iron2?.shot3?.optiony_value) + parseInt(step?.iron2?.shot3?.option1_value) + parseInt(step?.iron2?.shot3?.option2_value);

    //     const iron3_shot1 = parseInt(step?.iron3?.shot1?.optionx_value) + parseInt(step?.iron3?.shot1?.optiony_value) + parseInt(step?.iron3?.shot1?.option1_value) + parseInt(step?.iron3?.shot1?.option2_value);
    //     const iron3_shot2 = parseInt(step?.iron3?.shot2?.optionx_value) + parseInt(step?.iron3?.shot2?.optiony_value) + parseInt(step?.iron3?.shot2?.option1_value) + parseInt(step?.iron3?.shot2?.option2_value);
    //     const iron3_shot3 = parseInt(step?.iron3?.shot3?.optionx_value) + parseInt(step?.iron3?.shot3?.optiony_value) + parseInt(step?.iron3?.shot3?.option1_value) + parseInt(step?.iron3?.shot3?.option2_value);


    //     const iron1 = iron1_shot1 + iron1_shot2 + iron1_shot3;
    //     const iron2 = iron2_shot1 + iron2_shot2 + iron2_shot3;
    //     const iron3 = iron3_shot1 + iron3_shot2 + iron3_shot3;


    //     if (iron1 <= iron2 && iron1 <= iron3) {
    //         lowestIron = 1;
    //     }
    //     else if (iron2 <= iron1 && iron2 <= iron3) {
    //         lowestIron = 2;
    //     }
    //     else if (iron3 <= iron1 && iron3 <= iron2) {
    //         lowestIron = 3;
    //     }
    //     else {
    //         lowestIron = 1;
    //     }


    //     if (step?.name == "white Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Low";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Mid";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "High";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step?.name == "Black Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Upright";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Standard";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Flat";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step?.name == "Blue Irons") {
    //         console.log("white Irons lowestIron", iron1, iron2, iron3);
    //         if (lowestIron == 1) {
    //             bestLabel = "Heavy";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Light";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step?.name == "Pink Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Hard";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Soft";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step?.name == "Purple Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Firm Tip";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Soft Mid";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Firm Butt";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step?.name == "Red Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Oversize";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Mid";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Standard";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step?.name == "Orange Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Long";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Short";
    //             bestposition = 3;
    //         }
    //     }

    //     if (step?.name == "Green Irons") {
    //         if (lowestIron == 1) {
    //             bestLabel = "Heavy";
    //             bestposition = 1;
    //         } else if (lowestIron == 2) {
    //             bestLabel = "Medium";
    //             bestposition = 2;
    //         } else if (lowestIron == 3) {
    //             bestLabel = "Light";
    //             bestposition = 3;
    //         }
    //     }
    //     return { iron1: iron1, iron2: iron2, iron3: iron3, label: bestLabel, bestposition: bestposition };
    // }

    const getprojectdata = () => {
        // setApicall(true);
        // const data = {
        //     'project_id': params.id
        // }
        // getPrescription(data).then((res) => {
        //     console.log("res", res);
        //     if (!res.data.status) {
        //         alert(res.data.data[0].detail);
        //     } else {
        //         setApicall(false);
        //         setPrescriptionid(res.data.data._id)
        //     }

        // }).catch((error) => {
        //     console.log("error", error);
        // });
    }

    useEffect(() => {
        if(prescription && prescription._id){
            setPrescriptionid(prescription._id)
        }
    },[prescription]);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <ReactNotifications />

                        <Modal
                            show={showConfirmation}
                            onHide={handleCloseConfirmation}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to remove this Project?</h4>
                                    <div className="confirmation-buttons mt-4">
                                        <Button variant="danger" onClick={deleteproject}>
                                            Yes
                                        </Button>
                                        {' '}
                                        <Button variant="secondary" onClick={handleCloseConfirmation}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">Golf Swing</h3>
                                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className='modal-long-form'>
                                    <div className="irons-content">
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Getting Started
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="dashboard-sec">
                                            <div className="container-fulid">
                                                <Form noValidate validated={validated}>
                                                    <div className="club_fitting_box_section follow-view-form mt-4">
                                                        <div className="form-box-inner">
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Name</label>
                                                                    <div className="followup-name-view">
                                                                        <input type="text"
                                                                            required
                                                                            value={formData.firstname}
                                                                            disabled
                                                                            className={`form-control dashboard-input-box-2 me-1`}
                                                                            placeholder="First"
                                                                            name={"firstname"}
                                                                        />
                                                                        <input type="text"
                                                                            required
                                                                            disabled
                                                                            value={formData.lastname}
                                                                            className={`form-control dashboard-input-box-2 `}
                                                                            placeholder="Last"
                                                                            name={"lastname"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        className={`form-control dashboard-input-box-2`}
                                                                        placeholder="Email Address"
                                                                        name="email"
                                                                        disabled
                                                                        value={formData.email}
                                                                        required />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please enter valid email
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                            <div className="form-item">
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Phone</label>
                                                                    <input type="text" name={"phone"}
                                                                        disabled
                                                                        value={formData.phone}
                                                                        className={`form-control dashboard-input-box-2 `}
                                                                        placeholder="Phone Number" />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Please enter phone number
                                                                    </Form.Control.Feedback>
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: 'none' }}>
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Wrist to Floor</label>
                                                                    <input type="text" className="form-control dashboard-input-box w-18" name={"wrist_to_floor"} placeholder="in." />
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: 'none' }}>
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                                    <input type="text" className="form-control dashboard-input-box w-18" name={"shoulder_to_wrist"} placeholder="in." />
                                                                </div>
                                                            </div>
                                                            <div className="form-item" style={{ display: 'none' }}>
                                                                <div className="form-group custom-form-group">
                                                                    <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                                    <input type="text" className="form-control dashboard-input-box w-18" name={"elbow_to_wrist"} placeholder="in." />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Your Height
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="dashboard-sec">
                                            <div className="club_fitting_box_section mt-4">
                                                <div className="form-item height-form-iteam">
                                                    <div className="form-group custom-form-group mb-0">
                                                        <label className="dashboard-form-lable">Height</label>
                                                        <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                <option value={0}>ft.</option>
                                                                <option value="4">4 ft.</option>
                                                                <option value="5">5 ft.</option>
                                                                <option value="6">6 ft.</option>
                                                                <option value="7">7 ft.</option>
                                                            </select>
                                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                <option value={0}>in.</option>
                                                                <option value="1">0 in.</option>
                                                                <option value="2">1 in.</option>
                                                                <option value="3">2 in.</option>
                                                                <option value="4">3 in.</option>
                                                                <option value="5">4 in.</option>
                                                                <option value="6">5 in.</option>
                                                                <option value="7">6 in.</option>
                                                                <option value="8">7 in.</option>
                                                                <option value="9">8 in.</option>
                                                                <option value="10">9 in.</option>
                                                                <option value="11">10 in.</option>
                                                                <option value="12">11 in.</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Your Dexterity
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="dashboard-sec">
                                            <div className="club_fitting_box_section mt-4">
                                                <div className="form-item height-form-iteam">
                                                    <div className="form-group custom-form-group mb-0">
                                                        <label className="dashboard-form-lable">Dexterity</label>
                                                        <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                            <select required class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                <option value={0}>Dexterity</option>
                                                                <option value="1">Right Handed</option>
                                                                <option value="2">Left Handed</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sec-header-dash club-fitting-card-header">
                                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                <h3 className="box-title-lable">
                                                    Your Swing
                                                </h3>
                                            </div>
                                        </div>
                                        <div class="dashboard-sec">
                                            <div className="club_fitting_box_section mt-4">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <VideoUpload step="step0" onfilechange={(editfile) => setFirstVideo(editfile)} remotefittingimage={remotefittingimage} />
                                                            <VideoUpload2 step="step0" onfilechange={(editfile) => setSecondVideo(editfile)} remotefittingimage={remotefittingimage} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>


                        <div className="accordion-section">
                            <Accordion>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="0" className="club_fitting_accordion">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>Golf Swing</h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="sec-header-dash club-fitting-card-header">
                                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                            <h3 className="box-title-lable">
                                                                Getting Started
                                                            </h3>
                                                        </div>
                                                    </div>
                                                    <div className="dashboard-sec">
                                                        <div className="container-fulid">
                                                            <Form noValidate validated={validated}>
                                                                <div className="club_fitting_box_section follow-view-form mt-4">
                                                                    <div className="form-box-inner">
                                                                        <div className="form-item">
                                                                            <div className="form-group custom-form-group">
                                                                                <label className="dashboard-form-lable">Name</label>
                                                                                <div className="followup-name-view">
                                                                                    <input type="text"
                                                                                        required
                                                                                        disabled
                                                                                        value={formData.firstname}
                                                                                        className={`form-control dashboard-input-box-2 me-1`}
                                                                                        placeholder="First"
                                                                                        name={"firstname"}
                                                                                    />
                                                                                    <input type="text"
                                                                                        required
                                                                                        disabled
                                                                                        value={formData.lastname}
                                                                                        className={`form-control dashboard-input-box-2 `}
                                                                                        placeholder="Last"
                                                                                        name={"lastname"}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-item">
                                                                            <div className="form-group custom-form-group">
                                                                                <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    className={`form-control dashboard-input-box-2`}
                                                                                    placeholder="Email Address"
                                                                                    name="email"
                                                                                    value={formData.email}
                                                                                    disabled
                                                                                    required />
                                                                                <Form.Control.Feedback type="invalid">
                                                                                    Please enter valid email
                                                                                </Form.Control.Feedback>
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-item">
                                                                            <div className="form-group custom-form-group">
                                                                                <label className="dashboard-form-lable">Phone</label>
                                                                                <input type="text" name={"phone"}
                                                                                    disabled
                                                                                    value={formData.phone}
                                                                                    className={`form-control dashboard-input-box-2 `}
                                                                                    placeholder="Phone Number" />
                                                                                <Form.Control.Feedback type="invalid">
                                                                                    Please enter phone number
                                                                                </Form.Control.Feedback>
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-item" style={{ display: 'none' }}>
                                                                            <div className="form-group custom-form-group">
                                                                                <label className="dashboard-form-lable">Wrist to Floor</label>
                                                                                <input type="text" className="form-control dashboard-input-box w-18" name={"wrist_to_floor"} placeholder="in." />
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-item" style={{ display: 'none' }}>
                                                                            <div className="form-group custom-form-group">
                                                                                <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                                                <input type="text" className="form-control dashboard-input-box w-18" name={"shoulder_to_wrist"} placeholder="in." />
                                                                            </div>
                                                                        </div>
                                                                        <div className="form-item" style={{ display: 'none' }}>
                                                                            <div className="form-group custom-form-group">
                                                                                <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                                                <input type="text" className="form-control dashboard-input-box w-18" name={"elbow_to_wrist"} placeholder="in." />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Form>
                                                        </div>
                                                    </div>
                                                    <div className="sec-header-dash club-fitting-card-header">
                                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                            <h3 className="box-title-lable">
                                                                Your Height
                                                            </h3>
                                                        </div>
                                                    </div>
                                                    <div class="dashboard-sec">
                                                        <div className="club_fitting_box_section mt-4">
                                                            <div className="form-item height-form-iteam">
                                                                <div className="form-group custom-form-group mb-0">
                                                                    <label className="dashboard-form-lable">Height</label>
                                                                    <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                                        <select value={formData.height_ft} class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                            <option value={0}>ft.</option>
                                                                            <option value="4">4 ft.</option>
                                                                            <option value="5">5 ft.</option>
                                                                            <option value="6">6 ft.</option>
                                                                            <option value="7">7 ft.</option>
                                                                        </select>
                                                                        <select value={formData.height_in} class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled aria-label="Default select example">
                                                                            <option value={0}>in.</option>
                                                                            <option value="1">0 in.</option>
                                                                            <option value="2">1 in.</option>
                                                                            <option value="3">2 in.</option>
                                                                            <option value="4">3 in.</option>
                                                                            <option value="5">4 in.</option>
                                                                            <option value="6">5 in.</option>
                                                                            <option value="7">6 in.</option>
                                                                            <option value="8">7 in.</option>
                                                                            <option value="9">8 in.</option>
                                                                            <option value="10">9 in.</option>
                                                                            <option value="11">10 in.</option>
                                                                            <option value="12">11 in.</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="sec-header-dash club-fitting-card-header">
                                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                            <h3 className="box-title-lable">
                                                                Your Dexterity
                                                            </h3>
                                                        </div>
                                                    </div>
                                                    <div class="dashboard-sec">
                                                        <div className="club_fitting_box_section mt-4">
                                                            <div className="form-item height-form-iteam">
                                                                <div className="form-group custom-form-group mb-0">
                                                                    <label className="dashboard-form-lable">Dexterity</label>
                                                                    <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                                        <select value={formData.dexterity} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" aria-label="Default select example">
                                                                            <option value={0}>Dexterity</option>
                                                                            <option value="1">Right Handed</option>
                                                                            <option value="2">Left Handed</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="sec-header-dash club-fitting-card-header">
                                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                            <h3 className="box-title-lable">
                                                                Your Swing
                                                            </h3>
                                                        </div>
                                                    </div>
                                                    <div class="dashboard-sec">
                                                        <div className="club_fitting_box_section mt-4">
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="d-flex justify-content-center gap-2">
                                                                        <VideoUpload step="step0" onfilechange={(editfile) => setFirstVideo(editfile)} remotefittingimage={remotefittingimage} />
                                                                        <VideoUpload2 step="step0" onfilechange={(editfile) => setSecondVideo(editfile)} remotefittingimage={remotefittingimage} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12 ">
                                    <Accordion.Item eventKey="1" className="club_fitting_accordion white-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Bounce: <div className="light-text">{resultoutput.white.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput?.white?.bestposition === 1 ? 'active' : ''}`}>White 1 <br /><span class="result-value">{resultoutput?.white?.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput?.white?.bestposition === 2 ? 'active' : ''}`}>White 2 <br /><span class="result-value">{resultoutput?.white?.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput?.white?.bestposition === 3 ? 'active' : ''}`}>White 3 <br /><span class="result-value">{resultoutput?.white?.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="white">
                                                        <AccordionData step="step1" iron="iron1" title="White Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step1" iron="iron2" title="White Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step1" iron="iron3" title="White Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="2" className="club_fitting_accordion black-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Lie Angle:  <div className="light-text">{resultoutput.black.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.black.bestposition === 1 ? 'active' : ''}`}>Black 1 <br /><span class="result-value">{resultoutput.black.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.black.bestposition === 2 ? 'active' : ''}`}>Black 2 <br /><span class="result-value">{resultoutput.black.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.black.bestposition === 3 ? 'active' : ''}`}>Black 3 <br /><span class="result-value">{resultoutput.black.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="black">
                                                        <AccordionData step="step2" iron="iron1" title="Black Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step2" iron="iron2" title="Black Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step2" iron="iron3" title="Black Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="3" className="club_fitting_accordion blue-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Shaft Weight: <div className="light-text">{resultoutput.blue.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.blue.bestposition === 1 ? 'active' : ''}`}>Blue 1 <br /><span class="result-value">{resultoutput.blue.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.blue.bestposition === 2 ? 'active' : ''}`}>Blue 2 <br /><span class="result-value">{resultoutput.blue.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.blue.bestposition === 3 ? 'active' : ''}`}>Blue 3 <br /><span class="result-value">{resultoutput.blue.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="blue">
                                                        <AccordionData step="step3" iron="iron1" title="Blue Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step3" iron="iron2" title="Blue Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step3" iron="iron3" title="Blue Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="4" className="club_fitting_accordion pink-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Shaft Flex:  <div className="light-text">{resultoutput.pink.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.pink.bestposition === 1 ? 'active' : ''}`}>Pink 1 <br /><span class="result-value">{resultoutput.pink.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.pink.bestposition === 2 ? 'active' : ''}`}>Pink 2 <br /><span class="result-value">{resultoutput.pink.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.pink.bestposition === 3 ? 'active' : ''}`}>Pink 3 <br /><span class="result-value">{resultoutput.pink.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="pink">
                                                        <AccordionData step="step4" iron="iron1" title="Pink Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step4" iron="iron2" title="Pink Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step4" iron="iron3" title="Pink Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="5" className="club_fitting_accordion purpal-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Shaft Profile:  <div className="light-text">{resultoutput.purple.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.purple.bestposition === 1 ? 'active' : ''}`}>Purple 1 <br /><span class="result-value">{resultoutput.purple.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.purple.bestposition === 2 ? 'active' : ''}`}>Purple 2 <br /><span class="result-value">{resultoutput.purple.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.purple.bestposition === 3 ? 'active' : ''}`}>Purple 3 <br /><span class="result-value">{resultoutput.purple.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="purpal">
                                                        <AccordionData step="step5" iron="iron1" title="Purple Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step5" iron="iron2" title="Purple Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step5" iron="iron3" title="Purple Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="6" className="club_fitting_accordion red-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Grip Size:  <div className="light-text">{resultoutput.red.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.red.bestposition === 1 ? 'active' : ''}`}>Red 1 <br /><span class="result-value">{resultoutput.red.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.red.bestposition === 2 ? 'active' : ''}`}>Red 2 <br /><span class="result-value">{resultoutput.red.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.red.bestposition === 3 ? 'active' : ''}`}>Red 3 <br /><span class="result-value">{resultoutput.red.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="red">
                                                        <AccordionData step="step6" iron="iron1" title="Red Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step6" iron="iron2" title="Red Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step6" iron="iron3" title="Red Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="7" className="club_fitting_accordion orange-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Club Length:  <div className="light-text">{resultoutput.orange.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.orange.bestposition === 1 ? 'active' : ''}`}>Orange 1 <br /><span class="result-value">{resultoutput.orange.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.orange.bestposition === 2 ? 'active' : ''}`}>Orange 2 <br /><span class="result-value">{resultoutput.orange.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.orange.bestposition === 3 ? 'active' : ''}`}>Orange 3 <br /><span class="result-value">{resultoutput.orange.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="orange">
                                                        <AccordionData step="step7" iron="iron1" title="Orange Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step7" iron="iron2" title="Orange Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step7" iron="iron3" title="Orange Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="8" className="club_fitting_accordion green-iron">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5><span className="color"></span><span className="d-flex gap-1 align-items-center">Swing Weight:  <div className="light-text">{resultoutput.green.label}</div></span></h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="irons-content-accordion">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.green.bestposition === 1 ? 'active' : ''}`}>Green 1 <br /><span class="result-value">{resultoutput.green.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.green.bestposition === 2 ? 'active' : ''}`}>Green 2 <br /><span class="result-value">{resultoutput.green.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.green.bestposition === 3 ? 'active' : ''}`}>Green 3 <br /><span class="result-value">{resultoutput.green.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="green">
                                                        <AccordionData step="step8" iron="iron1" title="Green Iron" number={'1'} options={options1} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step8" iron="iron2" title="Green Iron" number={'2'} options={options2} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                        <AccordionData step="step8" iron="iron3" title="Green Iron" number={'3'} options={options3} shotOpction={shotOpction} defaultSelected={remotefittingdata} shortStrike={shortStrike} />
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                                <div className="col-md-12">
                                    <Accordion.Item eventKey="9" className="club_fitting_accordion">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view_club" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>Notes</h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="club-fitting-accordion-body">
                                                <div className="irons-content">
                                                    <div className="sec-header-dash club-fitting-card-header">
                                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                                            <h3 className="box-title-lable">
                                                                Your Notes
                                                            </h3>
                                                        </div>
                                                    </div>
                                                    <div className="club_fitting_box_section">
                                                        <textarea disabled class="dashboard-text-area" id="exampleFormControlTextarea1" rows="8" value={remotefittingdata?.step9?.notes} placeholder="Leave your note here..." ></textarea>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </div>
                            </Accordion>
                        </div>
                        <div className="btn-box-section mt-3">
                            <button className="btn btn-primary btn-remove" onClick={handleShowConfirmation}>Remove Fitting</button>
                        </div>

                    </>
                )
            }
        </>
    )
};

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = String(date.getUTCFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};


export default ClubFittingLeft;